import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { APPLICATION_ROUTES } from '../../../constants/application-routes';
import { AdobePageName } from '../../../services/adobe-launch/adobe-launch.pages';
import { AdobeLaunchService } from '../../../services/adobe-launch/adobe-launch.service';
import { TitleService } from '../../../services/title/title.service';
import { selectContactPersonType } from '../../../store/selectors/account-permissions.selector';
import { CONTENT_PLACEHOLDERS } from 'src/common/constants/constants';

import {
    ContentUtil,
    returnAllowedActions,
    returnAllowedCompareAccessLevelActionsList,
} from '../../../utils/content/content.util';
import { PageComponent } from '../page.component';
import { ClientSegmentContentDTO } from 'src/common/dtos/client-segment.dto';
import { ClientSegmentFacadeService } from '../../../services/client-segment-observer/client-segment.service';
import { Subject, takeUntil } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { IconModule } from '@vg-constellation/angular-20/icon';
import { BackLinkComponent } from '../../back-link/back-link.component';
import { SingleStatusListTileComponent } from '../../tiles/single-status-list-tile/single-status-list-tile.component';
@Component({
    selector: 'zci-about-page',
    templateUrl: './about-page.component.html',
    styleUrls: ['./about-page.component.scss'],
    imports: [
        NgFor,
        NgIf,
        IconModule,
        BackLinkComponent,
        SingleStatusListTileComponent,
    ],
})
export class AboutPageComponent extends PageComponent implements OnInit, OnDestroy {
    private readonly adobeLaunchService = inject(AdobeLaunchService);
    private titleService = inject(TitleService);
    private store = inject(Store);
    private readonly clientSegmentFacadeService = inject(ClientSegmentFacadeService);

    private horizontalHeaderIndexOfVerticalHeader = 0;

    appRoutes = APPLICATION_ROUTES;

    content = ContentUtil.content;

    readonly grantorContent = ContentUtil.grantorFragmentContent;

    allowedActions = returnAllowedCompareAccessLevelActionsList(this.content);

    contactPersonType$ = this.store.select(selectContactPersonType);

    contactPersonTypePlaceHolder: string = CONTENT_PLACEHOLDERS.CONTACT_PERSON_TYPE;

    eligibleAccounts = {
        matrix: this.content.about.tableEligibleAccounts.matrix,
        accountNames: this.content.about.tableEligibleAccounts.headers.vertical,
        accessTypes: this.content.about.tableEligibleAccounts.headers.horizontal.filter(
            (_, index) => index !== this.horizontalHeaderIndexOfVerticalHeader,
        ),
    };

    description: string;

    private destroy$ = new Subject<void>();

    ngOnInit(): void {
        this.titleService.setTitle(this.content.about.pageTitle);
        this.adobeLaunchService.pageLoad(AdobePageName.ABOUT_PAGE);

        this.clientSegmentFacadeService.clientSegmentContent$
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (content: ClientSegmentContentDTO) => {
                    if (content.orContactYourPoc) {
                        content.orContactYourPoc = ` ${content.orContactYourPoc}`;
                    }
                    this.description = this.grantorContent.access_comparison_table.text3
                        .replace('${phoneNumber}', content.phoneNumber)
                        .replace('${orContactYourPoc}', content.orContactYourPoc);
                },
            );
    }

    getAllowedActions = (column: number): string[] => returnAllowedActions(column, this.content);

    getEligibleAccounts = (column: number): string[] =>
        this.eligibleAccounts.accountNames.filter(
            (_, row) => this.eligibleAccounts.matrix[row][column],
        );

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
